import HttpService from '../HttpService'
import type { TravelerInformation } from '@/shared/types/api.types'
import { NEW_TRAVELER_ID } from '@/shared/constants/api.constants'
import { capitalize } from '@/shared/utils'

export class TravelersService extends HttpService {
  async getTravelers(): Promise<TravelerInformation[]> {
    const response = await this.get<TravelerInformation[]>('/gettravellers')
    // eslint-disable-next-line
    return response.sort((a, b) => Number(a.srNo) - Number(b.srNo))
  }

  async saveTraveler(information: TravelerInformation) {
    if (!information.srNo) information.srNo = NEW_TRAVELER_ID

    const formData = new FormData()
    Object.entries(information).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return
      }

      let newKey = key
      if (newKey !== 'srNo') {
        newKey = capitalize(newKey)
      }

      formData.append(newKey, value)
    })

    return await this.post('/savetraveller', formData)
  }

  async deleteTraveler(srNo: string) {
    return await this.post('/removetraveller', `srNo=${srNo}`)
  }

  async updateTravelInfo(quoteno: string) {
    const formData = new FormData()
    formData.append('quoteno', quoteno)
    return await this.post('/updatetravelinfo', formData)
  }
}
